import { BuilderSettings } from '../redux/types/builders';

export type PersonaTemplateResolution =
  | { templateId: string }
  | { error: string };

// require_age_21_active wins over every tier (errors instead of falling back to 18+ if unconfigured).
// Mirrors UtilsService.resolvePersonaTemplateId in nternow-mobile-service-backend.
export const resolvePersonaTemplateId = (builderSettings: BuilderSettings): PersonaTemplateResolution => {
  if (builderSettings.require_age_21_active) {
    const templateId = process.env.REACT_APP_PERSONA_AGE21_TEMPLATE_ID;

    if (!templateId) {
      return { error: 'Identity verification is not available right now. Please contact support.' };
    }

    return { templateId };
  }

  if (builderSettings.high_security_verification_active) {
    return { templateId: process.env.REACT_APP_PERSONA_HIGH_SECURITY_TEMPLATE_ID as string };
  }

  if (builderSettings.selfie_verification_active) {
    return { templateId: process.env.REACT_APP_PERSONA_SELFIE_TEMPLATE_ID as string };
  }

  return { templateId: process.env.REACT_APP_PERSONA_TEMPLATE_ID as string };
};
